export default __webpack_public_path__ + "static/1130-981dff0609e3035f665e9e97b73cd62f.gif";